import XIcon from "@redotech/redo-icons/x-close.svg";
import { ConciergeBlockStep } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import { RedoTextareaInputField } from "@redotech/redo-web/arbiter-components/input/redo-textarea-input-field";
import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Flex } from "@redotech/redo-web/flex";
import * as inspectorStyles from "@redotech/redo-web/inspector.module.css";
import {
  LabeledInput,
  LabelOrientation,
  LabelPosition,
  LabelSize,
} from "@redotech/redo-web/labeled-input";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import {
  FrontendStepType,
  PartialWithRequiredType,
  StepTypeDetailsProps,
} from "../steps";

const ConciergeBlockInspector = memo(function ConciergeBlockInspector(
  props: StepTypeDetailsProps<PartialWithRequiredType<ConciergeBlockStep>>,
) {
  const { step, setStep, onClose, showValidationErrors } = props;

  const promptError =
    showValidationErrors && !step.prompt ? "Prompt is required" : undefined;

  return (
    <Flex dir="column" gap="3xl">
      <Flex justify="space-between" py="sm">
        <Text fontSize="sm" fontWeight="semibold">
          Concierge
        </Text>
        {onClose && (
          <div className={inspectorStyles.closeButton} onClick={onClose}>
            <XIcon height="16" width="16" />
          </div>
        )}
      </Flex>
      <Flex dir="column" gap="lg">
        <RedoToggle
          label="Deactivate step"
          setValue={(disabled) => setStep({ ...step, disabled })}
          size="xs"
          value={step.disabled ?? false}
        />
        <LabeledInput
          label="Prompt for Shopper AI"
          orientation={LabelOrientation.VERTICAL}
          position={LabelPosition.ABOVE}
          size={LabelSize.EXTRA_SMALL}
        >
          <RedoTextareaInputField
            errorText={promptError}
            hintText="Describe what Shopper AI should say to the customer. The AI will write the actual message."
            placeholder="e.g. Send a friendly update that the package is on its way and include the tracking number."
            setValue={(prompt) => setStep({ ...step, prompt })}
            value={step.prompt || ""}
          />
        </LabeledInput>
      </Flex>
    </Flex>
  );
});

export const validateConciergeBlockStep = (
  step: PartialWithRequiredType<ConciergeBlockStep>,
): boolean => !!step.prompt;

export const conciergeBlockStepType: FrontendStepType<
  PartialWithRequiredType<ConciergeBlockStep>
> = {
  valid: validateConciergeBlockStep,
  type: "custom",
  customInspector: ConciergeBlockInspector,
};
